import React from 'react';
import ConfirmModal from '../Elements/UI/ConfirmModal';

const Conformationpollmodal = ({ show, onClose, onConfirm }) => {
  return (
    <ConfirmModal
      show={show}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Delete poll?"
      message="The poll and all its votes will be removed. This can't be undone."
    />
  );
};

export default Conformationpollmodal;
